// src/components/ChefBookingCard.jsx
import React from 'react';
import '../styles/ChefBookingCard.css';

const ChefBookingCard = ({ name, specialty, rating, image, onBook }) => {
  return (
    <div className="chef-card">
      <img
        src={image || '/placeholder-chef.png'}
        alt={`Chef ${name}`}
        className="chef-image"
        loading="lazy"
      />

      <div className="chef-info">
        <h3>{name}</h3>
        <p><strong>Specialty:</strong> {specialty || 'Not specified'}</p>
        <p>
          <strong>Rating:</strong> {rating ? `⭐ ${rating}` : 'No ratings yet'}
        </p>

        {onBook && (
          <button className="chef-book-btn" onClick={onBook} aria-label={`Book chef ${name}`}>
            Book This Chef
          </button>
        )}
      </div>
    </div>
  );
};

export default ChefBookingCard;
